import publicRoutes from '@/router/routes/public.js'
import privateRoutes from '@/router/routes/private.js'

export default publicRoutes.concat(privateRoutes)